import React from 'react';
import { MainContentContainer, MainSection } from '../OtherPages.styles';
import SideContainerComponent from '../SideContainer.component';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import Header from './Header';
import SummaryTandC from './Summary';
import Liability from './Liability';
import Payment from './Payment';
import IntellectualProperty from './Property';
import Services from './Services';
import Termination from './Termination';
import ContentProperty from '../PrivacyPolicy/ContentProperty';

const TermsAndConditions = () => {
  return (
    <MainContentContainer>
      <HelmetHelper
        title="Terms and Conditions"
        description="Terms and conditions for yoda safety services"
      />
      <SideContainerComponent />
      <MainSection>
        <h2>Terms & Conditions</h2>
        <Header />
        <Services />
        <ContentProperty />
        <Termination />
        <Payment />
        <IntellectualProperty />
        <Liability />
        <SummaryTandC />
      </MainSection>
    </MainContentContainer>
  );
};

export default TermsAndConditions;
